import { render, staticRenderFns } from "./DeleteEventModal.vue?vue&type=template&id=3d38fac0&scoped=true"
import script from "./DeleteEventModal.vue?vue&type=script&lang=js"
export * from "./DeleteEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38fac0",
  null
  
)

export default component.exports